var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPnpm = function SvgPnpm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "76.58987244897958 44 164.00775510204068 164",
    width: 160.01,
    height: 160
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M237.6 95L187.6 95L187.6 45L237.6 45L237.6 95Z",
    id: "pnpm_svg__arNRoK435"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.59 95L132.59 95L132.59 45L182.59 45L182.59 95Z",
    id: "pnpm_svg__a3H2WU7Px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.59 95L77.59 95L77.59 45L127.59 45L127.59 95Z",
    id: "pnpm_svg__b1DInM56vl"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.6 150L187.6 150L187.6 100L237.6 100L237.6 150Z",
    id: "pnpm_svg__a7LFlgQIwu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.59 150L132.59 150L132.59 100L182.59 100L182.59 150Z",
    id: "pnpm_svg__amwLiZcuo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.59 205L132.59 205L132.59 155L182.59 155L182.59 205Z",
    id: "pnpm_svg__f3Peu5RWan"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.6 205L187.6 205L187.6 155L237.6 155L237.6 205Z",
    id: "pnpm_svg__a6DXBfqPa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.59 205L77.59 205L77.59 155L127.59 155L127.59 205Z",
    id: "pnpm_svg__c1GWSTH1z7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pnpm_svg__arNRoK435",
    opacity: 1,
    fill: "#f9ad00",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pnpm_svg__a3H2WU7Px",
    opacity: 1,
    fill: "#f9ad00",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pnpm_svg__b1DInM56vl",
    opacity: 1,
    fill: "#f9ad00",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pnpm_svg__a7LFlgQIwu",
    opacity: 1,
    fill: "#f9ad00",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pnpm_svg__amwLiZcuo",
    opacity: 1,
    fill: "#4e4e4e",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pnpm_svg__f3Peu5RWan",
    opacity: 1,
    fill: "#4e4e4e",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pnpm_svg__a6DXBfqPa",
    opacity: 1,
    fill: "#4e4e4e",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pnpm_svg__c1GWSTH1z7",
    opacity: 1,
    fill: "#4e4e4e",
    fillOpacity: 1
  })))));
};
export default SvgPnpm;